var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DefaultLocale", {
  enumerable: true,
  get: function get() {
    return _Locales.DefaultLocale;
  }
});
exports.LocalePickerKey = void 0;
Object.defineProperty(exports, "Locales", {
  enumerable: true,
  get: function get() {
    return _Locales.Locales;
  }
});
exports.i18n = void 0;
var _i18next = _interopRequireDefault(require("i18next"));
var _reactI18next = require("react-i18next");
var _Locales = require("./Locales");
var LocalePickerKey = exports.LocalePickerKey = 'lang';
var i18n = exports.i18n = _i18next["default"].createInstance();
i18n.use(_reactI18next.initReactI18next).init({
  lng: _Locales.DefaultLocale,
  preload: [_Locales.DefaultLocale],
  appendNamespaceToMissingKey: true,
  defaultNS: '',
  resources: {
    en: {
      format: {
        number: '{{value, number}}'
      }
    }
  },
  supportedLngs: Object.keys(_Locales.Locales),
  fallbackLng: _Locales.DefaultLocale,
  react: {
    useSuspense: false
  },
  compatibilityJSON: 'v3',
  interpolation: {
    escape: function escape(str) {
      var _entityMap = {
        '&': "&",
        '<': "<",
        '>': ">",
        '"': "\"",
        "'": "'",
        '/': "/"
      };
      if (typeof str === 'string') {
        return str.replace(/[&<>"'/]/g, function (s) {
          return _entityMap[s] || '';
        });
      }
      return str;
    }
  }
});